import { render, staticRenderFns } from "./Consultancy.vue?vue&type=template&id=2c50e664&scoped=true"
import script from "./Consultancy.vue?vue&type=script&lang=js"
export * from "./Consultancy.vue?vue&type=script&lang=js"
import style0 from "./Consultancy.vue?vue&type=style&index=0&id=2c50e664&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c50e664",
  null
  
)

export default component.exports